/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Head from 'next/head';
import { useAmp } from 'next/amp';
import Container from '../../atoms/Container';
import Styles from './Header.css';
import CleanButton from '../../atoms/CleanButton/CleanButton';
import Menu from '../MenuRastreadores';
import SidebarContent from './SidebarContent';
import SearchBar from '../SearchBar/SearchBar';

function isValidNumber(value) {
  if (value === null || value === undefined || isNaN(value)) return false;
  return true;
}

function HeaderRastreadores({ disableMenu, importPrefix, isHome }) {
  const isAmp = useAmp();
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [searchOpen, setSearchOpen] = useState(false);
  const [menuExtraClasses, setMenuExtraClasses] = useState('sidebar-display-hidden');

  const changeMenuState = (open) => {
    if (open) {
      setMenuExtraClasses('sidebar-display-visible');
      setTimeout(() => setMenuOpen(true), 50);
      return;
    }

    setMenuOpen(false);
    setTimeout(() => {
      setMenuExtraClasses('sidebar-display-hidden');
    }, 250);
  };

  return (
    <>
      <Head>
        <link
          rel="preload"
          href={`${importPrefix}static/amp/shared/assets/logo_mobile_santander.svg`}
          as="image"
          media="(max-width: 991px)"
        />
        {/* <link
          rel="preload"
          href={`${importPrefix}static/amp/shared/assets/logo_2.svg`}
          as="image"
          media="(min-width: 992px)"
        /> */}
      </Head>
      <header id="santander-header" className={'regular'}>
        <Container className="wrapper desktop">
          <a href={`${importPrefix}.`} id="logo-santander-header-desktop">
            <img
              src={`${importPrefix}static/amp/shared/assets/logo_2.svg`}
              alt="Logo Santander Financiamentos"
              height="20"
              width="251"
            />
          </a>
        </Container>

        <Container className={`wrapper-mb mobile ${!isAmp && searchOpen ? 'hide-header' : ''}`}>
          <CleanButton
            style={{
              visibility: disableMenu ? 'hidden' : 'visible',
            }}
            onClick={(ev) => {
              ev.preventDefault();
              changeMenuState(!menuOpen);
            }}
          >
            {!menuOpen && (
              <img
                id="icon-open-menu"
                src={`${importPrefix}static/amp/shared/assets/ic_menu.svg`}
                alt="Abrir menu"
                height="22"
                width="22"
              />
            )}

            <span hidden={!menuOpen} id="icon-close-menu">
              <img
                src={`${importPrefix}static/amp/shared/assets/ic_close.svg`}
                alt="Fechar menu"
                height="18"
                width="18"
              />
            </span>
          </CleanButton>

          <a href={`${importPrefix}.`} id="logo-santander-header-mobile">
            <img
              src={`${importPrefix}static/amp/shared/assets/logo_2.svg`}
              alt="Logo Santander Financiamentos"
              height="20"
            />
          </a>
          <span />
        </Container>
      </header>
      <section id="fixed-spacer" />
      <Menu importPrefix={importPrefix} />

      <div
        id="santander-sidebar"
        className={`sidebar-ampless ${menuOpen ? 'opened' : ''} ${menuExtraClasses}`}
        aria-hidden={menuOpen ? 'false' : 'true'}
      >
        <Container className="container-mobile-header" aria-hidden={menuOpen ? 'false' : 'true'}>
          <div className={`nested-menu-ampless ${isValidNumber(activeIndex) ? ' opened' : ''}`}>
            <SidebarContent
              importPrefix={importPrefix}
              onChange={(index) => {
                setActiveIndex(index);
              }}
              setMenuOpen={changeMenuState}
            />
          </div>
        </Container>
      </div>

      <style jsx>{Styles}</style>
    </>
  );
}

HeaderRastreadores.defaultProps = {
  importPrefix: '',
};

export default HeaderRastreadores;
